import { RadioCardGroup } from "./RadioCardGroup";
import { RadioCardItem } from "./RadioCardItem";

export const RadioCard = { Group: RadioCardGroup, Item: RadioCardItem };
